import { action } from 'typesafe-actions';

import { ISearchResponse } from 'ApiPackage/SearchModule/interfaces/ISearchResponse';

import { IKnmSearchInitFilter } from '../interfaces/IKnmSearchInitFilter';
import { SearchActionsEnum } from '../enums/SearchActionsEnum';
import { FilterOptions } from '../types/FilterOptions';

export const searchSetSearchString = (searchString: string) =>
  action(SearchActionsEnum.SEARCH_SET_SEARCH_STRING, { searchString });
export const searchGetResultData = () => action(SearchActionsEnum.SEARCH_GET_RESULT_DATA);
export const searchGetResultDataNextPage = () => action(SearchActionsEnum.SEARCH_GET_RESULT_DATA_NEXT_PAGE);
export const searchSetResultData = (resultsData: ISearchResponse) =>
  action(SearchActionsEnum.SEARCH_SET_RESULT_DATA, { resultsData });
export const searchResetPage = () => action(SearchActionsEnum.SEARCH_RESET_PAGE);
export const searchSetFilter = (filter: Partial<IKnmSearchInitFilter>) =>
  action(SearchActionsEnum.SEARCH_SET_FILTER, { filter });
export const searchExportData =
  (exportFn: (params: string, captchaToken: string) => Promise<Blob>, checkFilename: string) => () =>
    action(SearchActionsEnum.SEARCH_EXPORT_DATA, { exportFn, checkFilename });
export const searchGetFilterOptions = () => action(SearchActionsEnum.SEARCH_GET_FILTER_OPTIONS);
export const searchSetFilterOptions = (filterOption?: FilterOptions) =>
  action(SearchActionsEnum.SEARCH_SET_FILTER_OPTIONS, { filterOption });
export const searchSetOrder = (order: string) => action(SearchActionsEnum.SEARCH_SET_ORDER, { order });
